export function isCryptoRandomUUIDPolyfillNeeded(window: Window): boolean {
  return typeof window.crypto !== 'undefined' && typeof window.crypto.randomUUID === 'undefined';
}

/**
 * https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/2117523#2117523
 */
export function polyfillCryptoRandomUUID(): void {
  (window as any).crypto.randomUUID = () => {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (parseInt(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (parseInt(c) / 4)))).toString(16)
    );
  };
}
